// React Lib
import React, { useState, useEffect } from "react";
// Component Styles
import { useStyles } from "./SystemLogStyles";
// @otg-one/ui_components/components
import { Chip, Typography, Separator } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY, LogSeverity, getLogSeverityStyle } from "../../constants";
// Material UI Core
import Grid from '@mui/material/Grid';
// Icon
import NoMessage from "../../icons/NoMessage/NoMessage";
import { Dropdown } from "../index";
import moment from 'moment';
const SystemLogListHeader = props => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, "Status")),
        React.createElement(Grid, { item: true, md: 8 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, "Activity")),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, "Time")),
        React.createElement(Grid, { item: true, md: 12 },
            React.createElement(Separator, { type: "n200", width: 2, marginTop: -8 }))));
};
const SystemLogList = (props) => {
    const { log, global, chipStyle } = props;
    const IconLog = getLogSeverityStyle(log.severity).icon;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement("div", { style: { marginTop: -10 } },
                React.createElement(Chip, { style: chipStyle, icon: IconLog, backgroundColor: getLogSeverityStyle(log.severity).backgroundColor, color: getLogSeverityStyle(log.severity).fontColor }, log.severity))),
        global && React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[100], style: { marginTop: -10 } },
                log.client_name,
                " ",
                React.createElement("br", null),
                " ",
                log.system_name)),
        React.createElement(Grid, { item: true, md: global ? 6 : 8 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[100], style: { marginTop: -10 } }, log.message)),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[100], style: { marginTop: -10 } }, moment(log.createdOn).format('MMM DD, YYYY - HH:mm')))));
};
export const SystemLog = (props) => {
    const classes = useStyles(props);
    const { id, logs, global, style, textSystemLog, textNoSystemMessage, dropdown_Menu, dropdownStyle, chipStyle } = props;
    const [dataLogs, setDataLogs] = useState(logs);
    const [filterData, setFilterData] = useState(LogSeverity.ALL);
    useEffect(() => {
        let currentDataLogs = [...logs];
        let filteredDataLogs = [];
        if (filterData === LogSeverity.ALL) {
            filteredDataLogs = currentDataLogs;
        }
        else {
            filteredDataLogs = currentDataLogs.filter(function (log) {
                const lc = log.severity;
                return lc.includes(filterData);
            });
        }
        setDataLogs(filteredDataLogs);
    }, [filterData]);
    useEffect(() => {
        setDataLogs(logs);
    }, [logs]);
    useEffect(() => {
        console.log(DROPDOWN_MENU);
    });
    const DROPDOWN_MENU = [
        {
            // text: "Show All",
            text: [dropdown_Menu[0].text],
            onClick: () => { setFilterData(LogSeverity.ALL); },
        },
        {
            // text: "Trace",
            text: [dropdown_Menu[1].text],
            onClick: () => { setFilterData(LogSeverity.TRACE); },
        },
        {
            // text: "Debug",
            text: [dropdown_Menu[2].text],
            onClick: () => { setFilterData(LogSeverity.DEBUG); },
        },
        {
            // text: "Info",
            text: [dropdown_Menu[3].text],
            onClick: () => { setFilterData(LogSeverity.INFO); },
        },
        {
            // text: "Warn",
            text: [dropdown_Menu[4].text],
            onClick: () => { setFilterData(LogSeverity.WARN); },
        },
        {
            // text: "Error",
            text: [dropdown_Menu[5].text],
            onClick: () => { setFilterData(LogSeverity.ERROR); },
        },
        {
            // text: "Fatal",
            text: [dropdown_Menu[6].text],
            onClick: () => { setFilterData(LogSeverity.FATAL); },
        },
        {
            // text: "Off",
            text: [dropdown_Menu[7].text],
            onClick: () => { setFilterData(LogSeverity.OFF); },
        },
    ];
    return (React.createElement("div", { id: id, className: classes.systemLogContainer, style: style },
        React.createElement(Typography, { id: `${id}-system-log`, fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: Color.neutral[100] }, textSystemLog),
        React.createElement("div", { style: { position: "absolute", top: 16, right: 24 } },
            React.createElement(Dropdown, { menu: DROPDOWN_MENU, selected: DROPDOWN_MENU[0].text, type: "SELECTION", backgroundColor: Color.neutral[0], style: dropdownStyle })),
        React.createElement("div", { id: `${id}-latest-activity-list-container`, className: classes.systemLogListContainer, style: {
                paddingTop: 10
            } },
            React.createElement(Grid, { container: true, style: { flexGrow: 1 }, spacing: 2, alignItems: "center" }, dataLogs ? dataLogs.length > 0 ? dataLogs.map((log, index) => (React.createElement(React.Fragment, null,
                React.createElement(SystemLogList, { log: log, global: global, chipStyle: chipStyle }),
                index !== dataLogs.length - 1 && (React.createElement(Grid, { item: true, md: 12 },
                    React.createElement(Separator, { type: "n200", width: 1, marginTop: -8 })))))) :
                React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "center", className: classes.noMessageWrapper },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(Grid, { container: true },
                            React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                                React.createElement(NoMessage, { className: classes.noMessageIcon })),
                            React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                                React.createElement("span", { className: classes.noMessageContent }, textNoSystemMessage))))) : null))));
};
SystemLog.defaultProps = {
    logs: [],
    global: true,
    textSystemLog: 'System Log',
    textNoSystemMessage: 'No System Message',
    dropdown_Menu: [
        { text: 'Show All' },
        { text: 'Trace' },
        { text: 'Debug' },
        { text: 'Info' },
        { text: 'Warn' },
        { text: 'Error' },
        { text: 'Fatal' },
        { text: 'Off' },
    ]
};
export default React.memo(SystemLog);
